import { all } from 'redux-saga/effects';
import app from './app';
import user from './user';
import fantasyCricket from './fantasy_cricket';
import fantasySubstitute from './fantasy_substitute';
import fantasyKabaddi from './fantasy_kabaddi';
import fantasyYesNo from './fantasy_yes_no';
import fantasyFootball from './fantasy_football';
import account from './account';
import more from './more';

export default function* rootSaga() {
  yield all([
    app(),
    user(),
    fantasyCricket(),
    fantasySubstitute(),
    fantasyKabaddi(),
    fantasyYesNo(),
    fantasyFootball(),
    account(),
    more()
  ]);
}
